import { render, staticRenderFns } from "./TreatmentCardList.vue?vue&type=template&id=db50b2ae&scoped=true&"
import script from "./TreatmentCardList.vue?vue&type=script&lang=js&"
export * from "./TreatmentCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db50b2ae",
  null
  
)

export default component.exports